'use client';

import {
  createContext,
  ReactNode,
  useContext,
  useTransition,
  TransitionStartFunction,
} from 'react';

type FeedControlsValue = {
  isPending: boolean;
  startTransition: TransitionStartFunction;
};

const FeedControlsContext = createContext<FeedControlsValue>({
  isPending: false,
  startTransition: () => {},
});

export function FeedControlsProvider({ children }: { children: ReactNode }) {
  const [isPending, startTransition] = useTransition();
  return (
    <FeedControlsContext.Provider value={{ isPending, startTransition }}>
      {children}
    </FeedControlsContext.Provider>
  );
}

export function useFeedControls() {
  return useContext(FeedControlsContext);
}
